import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { Jalon } from '../models/jalon.model';
import { UpdateJalonRequest } from '../requests/update-jalon-request';

@Injectable({
  providedIn: 'root',
})
export class JalonService {
  #http = inject(HttpClient);

  readonly BASE_URL = `/jalons`;

  findById(idJalon: string): Observable<Jalon> {
    return this.#http.get<Jalon>(this.BASE_URL + '/' + idJalon);
  }

  modifier(idJalon: string, data: UpdateJalonRequest) {
    return this.#http.put<{ path: string }>(this.BASE_URL + '/' + idJalon, data);
  }
}
